import React, { useState } from 'react';
import { canEditTicket, eligibleForAddDocketDetails, getIsToShowAddDocketButton, serviceTypeIds, } from '../TicketController';
import { handHelding } from '../TicketTableComponent';
import ButtonScogoOrange from '../../../common/Buttons/ButtonScogoOrange';
import { getLookupWitHDefaultValue } from '../../../utils/common';
import IconToolTip from '../../../common/IconToolTip';
import { DateComponent } from '../../../common/TableReusableColumns';
import Popover from '@mui/material/Popover';
import { convertIntoRupee } from '../../../utils/utils';
import { useDispatch } from 'react-redux';
import { openCustomModal } from '../../../actions/modal';
import AddDocketDetails from '../Modal/AddDocketDetails';

export const Shipping = ({ ticket }) => {
    const forwardLogisitics = ticket.tracking_details;
    let showAddDocket = !forwardLogisitics && canEditTicket(ticket) && eligibleForAddDocketDetails(ticket);
    if (ticket.org_id === 'org_3EFexa9JhRW6SyV9LYhq6q3We2F') { // Hardcode for now. Need to update
        showAddDocket = true;
    }
    const dispatch = useDispatch();

    const onAddDocketCLick = () => {
        let heading = 'Add Docket Details';
        let modalComponent = (
            <AddDocketDetails ticket={ticket} />
        );
        let modalWidth = '60rem',
            modalHeight = 'auto';
        dispatch(openCustomModal({ modalComponent, heading, modalWidth, modalHeight }));
    };

    return (
        <div>
            {forwardLogisitics && (
                <ShippingDetails
                    awbNo={forwardLogisitics.docket_number}
                    imageClass='flip-horizontally'
                    status={forwardLogisitics.status}
                    carrier={forwardLogisitics.vendor.name}
                    pod={forwardLogisitics.pod_url}
                    delivery_date={forwardLogisitics.delivery_date}
                    cost={convertIntoRupee(forwardLogisitics.cost_in_paisa)}
                />
            )}
            {showAddDocket && (
                <div className='mt-1'>
                    <ButtonScogoOrange buttonClass='text-font10' textOrComponent={'Add Docket'} onClick={() => onAddDocketCLick()} />
                </div>
            )}
        </div>
    );
}

const ShippingDetails = (props) => {
    const { awbNo, status, carrier, pod, delivery_date, label, cost } = props;

    const current_status = getLookupWitHDefaultValue({
        lookup: {
            INTRASIT: 'orange',
            DELIVERED: 'text-scogosuccess',
            RTO_DELIVERED: 'text-scogosuccess',
            [handHelding]: 'text-scogosuccess',
        },
        defaultValue: 'text-scogoclosed',
    });

    const isHandHelding = handHelding === status;

    return (
        <div className='w-full block'>
            <div className='md:block flex-wrap flex items-center'>
                <div className='flex md:mr-0 mr-2 md:mb-0'>
                    <div>
                        <IconToolTip title={label}>
                            <p className='text-font11 text-scogo15 font-medium'>{status}</p>
                        </IconToolTip>
                    </div>
                </div>
                {!isHandHelding && (
                    <div className='md:block flex md:mr-0 mr-2 flex-wrap items-center md:mb-0'>
                        {awbNo && (
                            <p className='text-font10 font-normal md:mr-0 mr-2 mb-1'>
                                <span className='text-scogogray'>AWB No:</span> <span className='text-scogoprimary ml-1 text-font11'>{awbNo}</span>
                            </p>
                        )}

                        <div className="grid grid-cols-1 gap-1">
                            {[
                                { value: carrier, label: 'Carrier', link: false },
                                { value: pod, label: 'POD', link: pod },
                                { value: cost, label: 'Cost', link: '' },
                            ].map(({ label, value, link }) => {
                                if (!value) return null;
                                return (
                                    <div key={label} className="flex items-center">
                                        {link ?
                                            <a href={value} alt="" target='_blank' rel="noreferrer" className='text-scogogray font-medium text-font10'>
                                                {label}: <span className='text-scogobgsky hover:text-scogoorange font-normal break-all ml-1 text-font11'>{value}</span>
                                            </a>
                                            : <span className='text-scogogray font-medium text-font10'>
                                                {label}: <span className='text-black font-normal break-all ml-1 text-font11'>{value}</span>
                                            </span>}
                                    </div>
                                );
                            })}

                            {delivery_date && (
                                <div className="flex items-center">
                                    <span className='text-scogogray font-medium text-font10'>Delivery Date:</span>
                                    <span className="ml-1"><DateComponent date={delivery_date} timeFormat='DD MMM YYYY' /></span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

const ViewMorwPopup = ({
    children,
    anchorOrigin = {
        vertical: 'top',
        horizontal: 'center',
    },
    transformOrigin = {
        vertical: 'bottom',
        horizontal: 'center',
    },
    popup
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
        <>
            <div aria-describedby={id} onClick={handleClick} variant='contained' className='hover:underline cursor-pointer inline'>
                {children}
            </div>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
                className="shadow-lg"
            >
                {popup}
            </Popover>
        </>
    );
};
